import api from './client';

export const userApi = {
  list: () => api.get('/api/users'),
  availableShain: () => api.get('/api/users/available-shain'),
  create: (data) => api.post('/api/users', data),
  update: (shainCode, data) => api.patch(`/api/users/${shainCode}`, data),
  resetPassword: (shainCode, data) => api.post(`/api/users/${shainCode}/reset-password`, data),
  deactivate: (shainCode) => api.delete(`/api/users/${shainCode}`),
};
